import styled, { css } from 'styled-components';

interface ButtonProps {
  buttonDisable?: boolean;
}

export const Container = styled.button<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;

  font-size: 2.2rem;

  width: 100%;
  height: 5.8rem;

  background: linear-gradient(107deg, #ffd503 0%, #ffdf22 100%);
  border-radius: 5rem;

  transition: 180ms ease-in;

  ${(props) =>
    props.buttonDisable &&
    css`
      background: gray;
      cursor: not-allowed;
    `}

  &:hover {
    opacity: 0.85;
  }
`;

export const ButtonText = styled.p`
  font-weight: bold;
  font-size: 2.4rem;
  letter-spacing: 0.5rem;
  color: #000000;
`;
